try {
    window.$ = window.jQuery = require('jquery');
    window.Swal = require("sweetalert2");
    window.select2 = require('select2');
} catch (e) {
}


require('bootstrap');

require('lazyload');

import PhotoSwipeLightbox from './files/photoswipe/dist/photoswipe-lightbox.esm.js';
import PhotoSwipe from './files/photoswipe/dist/photoswipe.esm.js';

require('owl.carousel');

window.PhotoSwipeLightbox = PhotoSwipeLightbox;
window.PhotoSwipe = PhotoSwipe;



import Alpine from 'alpinejs'

window.Alpine = Alpine
Alpine.start()

window.addEventListener("load", (event) => {
    $('.nav-link-home').addClass('show');
});

$(function () {
    $('.brand_slider .owl-carousel').owlCarousel({
        stagePadding: 50, rtl: true, loop: true, margin: 10, nav: true, dots: false, responsive: {
            0: {
                items: 1.5, stagePadding: 5,
            }, 400: {
                items: 2
            }, 768: {
                items: 3
            }, 1200: {
                items: 3
            }
        }
    });

    document.addEventListener("scroll", (event) => {
        let lastKnownScrollPosition = window.scrollY;
        if (lastKnownScrollPosition >= 100) {
            $('#sectionLogoHeader').addClass('hide-header-logo')
        } else {
            $('#sectionLogoHeader').removeClass('hide-header-logo')
        }
    });

    window.addEventListener('sweetAlert', function (e) {

        Swal.fire({
            title: e.detail.title,
            icon: e.detail.icon,
            toast: true,
            showConfirmButton: false,
            position: 'top-right',
            timer: 3000
        });
    });
    window.addEventListener('tooltip', function (e) {
        $('[data-toggle="tooltip"]').tooltip();
    });
    window.addEventListener('closeModal', function (e) {
        $('#' + e.detail).modal('hide');
    });
    window.addEventListener('openModal', function (e) {
        $('#' + e.detail).modal('show');
        $('.card-fixed').addClass('stop-scrolling');
    });

    window.addEventListener('select2', function (e) {
        $('.js-example-basic-multiple').select2();
    });

    $('#owlCarouselProjects .owl-carousel').owlCarousel({
        loop: true,
        rtl: true,
        center: true,
        margin: 0,
        autoWidth: false,
        nav: true,
        dots: true,
        navText: ["<i class='fas fa-chevron-right'></i>", "<i class='fas fa-chevron-left'></i>"],
        autoplay: false,
        responsive: {
            0: {
                items: 1.8,
            }, 767: {
                items: 3,
            }, 920: {
                items: 3,
            }, 1200: {
                items: 3,
            }, 1400: {
                items: 3,
            }, 1600: {
                items: 3,
            }
        }
    });

    $('#featureProductSection .owl-carousel').owlCarousel({
        loop: false,
        rtl: true,
        center: false,
        margin: 15,
        autoWidth: true,
        nav: true,
        dots: false,
        navText: ["<i class='fas fa-chevron-right'></i>", "<i class='fas fa-chevron-left'></i>"],
        autoplay: false,
    });

    $('#owlCarouselFeatureProduct .owl-carousel').owlCarousel({
        loop: true,
        rtl: true,
        center: false,
        margin: 15,
        autoWidth: true,
        nav: false,
        dots: false,
        navText: ["<i class='fas fa-chevron-right'></i>", "<i class='fas fa-chevron-left'></i>"],
        autoplay: true,
    });


    window.addEventListener('carouselProductsCategoryJs', function (e) {
        $('.carousel-products .owl-carousel').owlCarousel({
            loop: true,
            rtl: true,
            center: true,
            items: 10,
            margin: 5,
            autoWidth: true,
            lazyLoad: true,
            nav: true,
            dots: false,
            navText: [
                "<i class='fas fa-chevron-right ps-4'></i>",
                "<i class='fas fa-chevron-left pe-4'></i>"
            ],
            autoplay: false,
        })
    });

    window.addEventListener('FeatureProductCarousel', function () {
        const owl = $('#owlCarouselFeatureProduct'); // Owl carousel in question
        $(owl).trigger('destroy.owl.carousel'); // Destroy carousel instance
        $(owl).html($(owl).find('.owl-stage-outer').html()).removeClass('owl-loaded'); // Destroy carousel instance part 2
        $(owl).owlCarousel({
            loop: false,
            rtl: true,
            center: false,
            margin: 15,
            autoWidth: true,
            nav: true,
            dots: false,
            navText: ["<i class='fas fa-chevron-right'></i>", "<i class='fas fa-chevron-left'></i>"],
            autoplay: false,
        }); // Initialize Owl carousel once again with same config options
    });

    window.addEventListener('SliderCarousel', function (e) {
        $('#slider-carousel .owl-carousel').owlCarousel({
            loop: true,
            rtl: true,
            center: true,
            lazy: true,
            margin: 0,
            nav: true,
            dots: true,
            animateOut: 'fadeOut',
            autoplayTimeout: 3500,
            navText: ["<i class='fas fa-chevron-right'></i>", "<i class='fas fa-chevron-left'></i>"],
            autoplay: true,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1
                }
            }
        });
    });
    $('#slider-carousel .owl-carousel').owlCarousel({
        loop: true,
        rtl: true,
        center: true,
        lazy: true,
        margin: 0,
        nav: true,
        dots: true,
        animateOut: 'fadeOut',
        autoplayTimeout: 3500,
        navText: ["<i class='fas fa-chevron-right'></i>", "<i class='fas fa-chevron-left'></i>"],
        autoplay: true,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            }
        }
    });
    window.addEventListener('SliderCarouselMobile', function (e) {
        $('#slider-carousel .owl-carousel').owlCarousel({
            loop: true,
            rtl: true,
            center: true,
            margin: 0,
            nav: false,
            dots: false,
            animateOut: 'fadeOut',
            autoplayTimeout: 3500,
            navText: ["<i class='fas fa-chevron-right'></i>", "<i class='fas fa-chevron-left'></i>"],
            autoplay: true,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1
                }
            }
        });
    });

});


$(document).ready(function () {

    const gallerySite = new PhotoSwipeLightbox({
        gallery: '#gallerySite',
        children: 'a',
        pswpModule: PhotoSwipe
    });

    gallerySite.init();

    const aboutGallery = new PhotoSwipeLightbox({
        gallery: '#aboutGallery',
        children: 'a.item-gallery',
        pswpModule: PhotoSwipe
    });

    aboutGallery.init();

    const galleryMobile = new PhotoSwipeLightbox({
        gallery: '#galleryMobile',
        children: 'a',
        pswpModule: PhotoSwipe
    });

    galleryMobile.init();


    $('.product-scroll .owl-carousel').owlCarousel({
        stagePadding: 0,
        rtl: true,
        lazy:true,
        loop: false,
        margin: 5,
        nav: true,
        dots: true,
        autoplay: false,
        navText: [
            "<i class='fas fa-chevron-right'></i>",
            "<i class='fas fa-chevron-left'></i>"
        ],
        responsive: {
            0: {
                items: 1,
            }
        }


    });

    // When the user scrolls the page, execute myFunction
    window.onscroll = function () {
        stickyMenu();
    };

// Get the navbar
    var navbar = document.getElementById("navbar-site");

// Get the offset position of the navbar
    var sticky = navbar.offsetHeight;

// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
    function stickyMenu() {
        if (window.pageYOffset >= sticky) {
            navbar.classList.add("fix-header-scroll");
        } else {
            navbar.classList.remove("fix-header-scroll");
        }
    }

    // Enable Bootstrap tooltips on page load
    $('[data-bs-toggle="tooltip"]').tooltip();
    $('[data-bs-toggle="popover"]').popover();

    // Ensure Livewire updates re-instantiate tooltips
    if (typeof window.Livewire !== 'undefined') {
        window.Livewire.hook('message.processed', (message, component) => {
            $('[data-bs-toggle="tooltip"]').tooltip('dispose').tooltip();
            $('[data-bs-toggle="popover"]').popover('dispose').popover();
        });
    }


    jQuery('.btn-cart-header').click(function (e) {
        e.preventDefault();

        if ($('.mini-cart').hasClass('show'))
            $('.mini-cart').removeClass('show');
        else
            $('.mini-cart').addClass('show');

    });

    jQuery('.btn-tire-filter').click(function (e) {
        e.preventDefault();
        let target = $(this).attr('data-tab');
        $('.btn-tire-filter').removeClass('active');
        $('.tab-tire-filter').addClass('d-none');
        $(this).addClass('active');
        $(target).removeClass('d-none');
    });
    jQuery('.set-filter-tire-tab').change(function (e) {
        e.preventDefault();
        let target = $(this).attr('data-tab');
        Livewire.emit('set-tire-filter-tab', target)
    });

    let lastMouseDownX = 0;
    let lastMouseDownY = 0;
    let lastMouseDownWasOutside = false;

    const mouseDownListener = (event) => {
        lastMouseDownX = event.offsetX;
        lastMouseDownY = event.offsetY;
        lastMouseDownWasOutside = !$(event.target).closest('.mini-cart').length;

        if (lastMouseDownWasOutside && $('.mini-cart').hasClass('show')) $('.mini-cart').removeClass('show');
    };
    document.addEventListener('mousedown', mouseDownListener);


    jQuery(document).on("click", ".btn-tab-feature-product", function (e) {
        e.preventDefault();
        let btnTabs = $('.btn-tab-feature-product');
        let tab = $(this).attr('data-tab');

        if ($(this).hasClass('active')) return;

        $('#featureProductSection').addClass('d-none');
        btnTabs.removeClass('active');
        $(this).addClass('active')
        $('#loadingFeatureProduct').removeClass('d-none')
        Livewire.emit('set-tab-feature-product', tab);

    });


    $('#inputSearchHeader').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMember(value), 500)
    });

    let timeoutID = null;

    function findMember(str) {

        $('#spinnerLoadingSearch').removeClass('d-none');
        $('#loadingSearch').removeClass('d-none');
        Livewire.emit('set-query-search-modal', str);
    }


    $('#inputSearchSidebar').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMemberSideBar(value), 500)
    });


    function findMemberSideBar(str) {

        $('#spinnerLoadingSearchSidebar').removeClass('d-none');
        $('#preloadProductsList').removeClass('d-none');
        Livewire.emit('set-query-search-sidebar', str);
    }

    $('#inputSearchBrand').keyup(function (e) {
        clearTimeout(timeoutID);
        const value = e.target.value
        timeoutID = setTimeout(() => findMemberBrand(value), 500)
    });


    function findMemberBrand(str) {

        $('#preloadBrandList').removeClass('d-none');
        Livewire.emit('set-query-search-brand', str);
    }

    $("#rangeComment").on("input change", function () {
        let value = $("#rangeComment").val();
        document.getElementById('notActiveRangeComment').style.width = (100 - value * 20) + '%';
        document.getElementById('activeRangeComment').style.width = value * 20 + '%';
    });


    jQuery(document).on("click", ".btn-comment-like-product", function (e) {
        e.preventDefault();
        let likeMove = jQuery(this).closest('.btn-comment-like-product');
        let dataId = likeMove.attr('data-id');
        let count = likeMove.attr('data-count');
        Livewire.emit('comment-like-product', dataId, 'like');
        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas fa-thumbs-up ms-1 fa-lg"></i> ' + ++count);
            let dislike = jQuery('#btn-dislike-' + dataId).attr('data-count');

            if (jQuery('#btn-dislike-' + dataId).children('i').get(0).classList.contains('fas')) {
                --dislike;
                console.log(dislike);
                jQuery('#btn-dislike-' + dataId).attr('data-count', dislike);
            }

            jQuery('#btn-dislike-' + dataId).html('<i class="far ms-1 fa-thumbs-down fa-lg"></i> ' + dislike);
            likeMove.attr('data-count', count);
        } else {
            jQuery(this).html('<i class="far fa-thumbs-up ms-1 fa-lg"></i> ' + --count);
            likeMove.attr('data-count', count);
        }
    });

    jQuery(document).on("click", ".btn-comment-dislike-product", function (e) {
        e.preventDefault();
        let dislikeMove = jQuery(this).closest('.btn-comment-dislike-product');
        let dataId = dislikeMove.attr('data-id');
        let count = dislikeMove.attr('data-count');
        Livewire.emit('comment-like-product', dataId, 'dislike');

        if (jQuery(this).children('i').get(0).classList.contains('far')) {
            jQuery(this).html('<i class="fas fa-thumbs-down ms-1 fa-lg"></i> ' + ++count);
            var like = jQuery('#btn-like-' + dataId).attr('data-count');

            if (jQuery('#btn-like-' + dataId).children('i').get(0).classList.contains('fas')) {
                --like;
                console.log(like);
                jQuery('#btn-like-' + dataId).attr('data-count', like);
            }

            jQuery('#btn-like-' + dataId).html('<i class="far fa-thumbs-up ms-1 fa-lg"></i> ' + like);
            dislikeMove.attr('data-count', count);
        } else {
            jQuery(this).html('<i class="far fa-thumbs-down ms-1 fa-lg"></i> ' + --count);
            dislikeMove.attr('data-count', count);
        }
    });

    let loaderPage = setTimeout(Wt, 1000);    // function in offsite js file
    function Wt() {
        $("#preloaderMobile").addClass("d-none")
        if (loaderPage)
            clearTimeout(loaderPage)
    }

    $('#loginModal').on('shown.bs.modal', function () {
        $('#mobile').focus();
    });
    $('#searchModal').on('shown.bs.modal', function () {
        $('#inputSearchHeader').focus();
    });

});

